const baseSvg = require('!!raw-loader!./range-map.svg');

export default {
  data() {
    return {
      svg: undefined
    }
  },

  mounted() {
    let vm = this;
    this.svg = $(baseSvg);
    this.svg.appendTo(this.$el);

    // Bind evento click na camada.
    this.svg.find("g[id]").on("click", function (e) {
      vm.onClickState(this);
    });

    // para selecionar o estado de SP
    // vm.onClickState(this.svg.find("g[id=SP]"));
  },

  methods:{
    onClickState(state){
      let self = $(state);

      // Se não houver filho estado-active, ignora evento.
      if (!self.find('.estado-active').length) return;

      // Remove classe selected de todas as camadas
      this.svg.find('.estado-active').removeClass('selected');
      this.svg.find('.label-active').removeClass('selected');

      // Atribui classe selected para a camada selecionada
      self.find('.estado-active').addClass('selected');
      self.find('.label-active').addClass('selected');

      // Emite evento Vue
      let uf = self.attr('id');
      this.$emit('selected', uf);

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/external/range-map.js